module.exports = __webpack_public_path__ + "static/media/Sorghum1-3.07e13f85.PNG";